import CloudDataProvider from '../../DataProvider/CloudDataProvider';

export const defaultGetPresignedUrl = response => response?.data?.presignedUrl;

export function resolveUploadContentType(file, apis) {
  return (
    apis?.getUploadContentType?.(file) ||
    file?.type ||
    'application/octet-stream'
  );
}

/**
 * Runs create → get-upload-url → S3 PUT → confirm-upload.
 * Stops on the first failure.
 */
export async function runUploadSequence({
  dataProvider,
  file,
  apis,
  uploadFile = CloudDataProvider.uploadUsingPresignedUrl,
  getPresignedUrl = defaultGetPresignedUrl,
}) {
  const createResponse = await apis.createBatch(dataProvider, file);
  if (!createResponse?.ok) {
    return { ok: false, errors: createResponse?.errors };
  }

  const batchId = createResponse.data?.id;
  if (!batchId) {
    return {
      ok: false,
      errors: [{ message: 'Missing batch import id from create response' }],
    };
  }

  const uploadUrlResponse = await apis.getUploadUrl(
    dataProvider,
    batchId,
    file,
  );
  if (!uploadUrlResponse?.ok) {
    return { ok: false, errors: uploadUrlResponse?.errors };
  }

  const presignedUrl = getPresignedUrl(uploadUrlResponse);
  if (!presignedUrl) {
    return {
      ok: false,
      errors: [{ message: 'Missing presigned upload URL' }],
    };
  }

  const contentType = resolveUploadContentType(file, apis);

  try {
    await uploadFile({
      presignedUrl,
      file,
      contentType,
    });
  } catch (err) {
    return {
      ok: false,
      errors: [{ message: err?.message || 'File upload failed' }],
    };
  }

  return { ok: true, data: createResponse.data };
}
